import React, { useState } from "react";
import "./area-cards.scss";
import AreaCard from "./area-card";
import {
  DragDropContext,
  Draggable,
  Droppable,
  DropResult,
} from "react-beautiful-dnd";
import { useWindowDimensions } from "../../../hooks/useWindowDimensions";

interface Item {
  id: number;
  colors: string[];
  percentFillValue: number;
  cardInfo: {
    title: string;
    value: string;
    text: string;
  };
}

const AreaCards = () => {
  const [cardList, setCardList] = useState<Item[]>([
    {
      id: 1,
      colors: ["#e4e8ef", "#475be8"],
      percentFillValue: 80,
      cardInfo: {
        title: "Todays Sales",
        value: "$20.4K",
        text: "We have sold 123 items.",
      },
    },
    {
      id: 2,
      colors: ["#e4e8ef", "#4ce13f"],
      percentFillValue: 50,
      cardInfo: {
        title: "Todays Revenue",
        value: "$8.2K",
        text: "Available to payout",
      },
    },
    {
      id: 3,
      colors: ["#e4e8ef", "#f29a2e"],
      percentFillValue: 40,
      cardInfo: {
        title: "In Escrow",
        value: "$18.2K",
        text: "Available to payout",
      },
    },
  ]);
  const { width } = useWindowDimensions();

  const onDragEnd = (result: DropResult) => {
    if (!result.destination) return;

    const updatedList = [...cardList];

    const [movedItem] = updatedList.splice(result.source.index, 1);

    updatedList.splice(result.destination.index, 0, movedItem);

    setCardList(updatedList);
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable
        droppableId="drag-drop-list"
        direction={width > 580 ? "horizontal" : "vertical"}
      >
        {(provided, snapshot) => (
          <section
            className="content-area-cards"
            {...provided.droppableProps}
            ref={provided.innerRef}
          >
            {cardList.map((item, index) => (
              <Draggable
                key={item.id}
                draggableId={item.id.toString()}
                index={index}
              >
                {(provided) => (
                  <AreaCard
                    colors={item.colors}
                    provided={provided}
                    percentFillValue={item.percentFillValue}
                    cardInfo={item.cardInfo}
                    card={item}
                  />
                )}
              </Draggable>
            ))}
          </section>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default AreaCards;
